import React from 'react'
import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

interface ISelectionButton {
  key_: string
  label: string
  selectedOption: string
  changeSelectedUnit: () => void
}

const SelectionButton = ({ changeSelectedUnit, key_, label, selectedOption }: ISelectionButton) => {
  const isSelected = (value: string) => selectedOption === value

  return (
    <Button
      className={isSelected(key_) ? 'selected' : ''}
      onClick={() => changeSelectedUnit()}
    >
      {label}
    </Button>
  )
}

const Button = styled.div`
  width: 100%;
  text-align: center;
  padding: 5px 7px;
  border: 1px solid ${colors.colorBlack};
  cursor: pointer;
  background-color: ${colors.colorWhite};
  color: ${colors.colorBlack};
  &.selected {
    background-color: ${colors.colorBlack};
    color: ${colors.colorWhite};
  }
  user-select: none;
`

export default SelectionButton
